import { createCustomEnum } from "./customEnum";

export const CadenceTypes = createCustomEnum({
	Monthly: {
		value: 0,
		name: "monthly",
		displayName: "Monthly",
	},
	Annually: {
		value: 1,
		name: "annual",
		displayName: "Annually",
	},
	OneTime: {
		value: 2,
		name: "one_time",
		displayName: "One Time",
	},
	Consumption: {
		value: 3,
		name: "consumption",
		displayName: "Consumption",
	},
});

export const MonthlyDdl = [CadenceTypes.Monthly];

export const MonthlyAndAnnualDdl = [
	CadenceTypes.Monthly,
	CadenceTypes.Annually,
];

export const OneTimeDdl = [CadenceTypes.OneTime];
